export function initContactConfirmation() {
  const confirmation = document.getElementById( 'contact-confirmation' );
  const form = document.getElementById( 'contact-form' );

  if ( !confirmation || !form ) return;

  document.addEventListener( 'wpcf7mailsent', function( event ) {
    form.classList.add( 'hidden' );
    confirmation.classList.remove( 'hidden' );
  }, false );
}